import { render, staticRenderFns } from "./DocumentReorder.vue?vue&type=template&id=1a9f73a2&"
import script from "./DocumentReorder.vue?vue&type=script&lang=js&"
export * from "./DocumentReorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports